import './JiraProjectSelect.scss';
import { getDirectParent } from '@lib/popups';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { jiraSummarySelectors } from './@arch/selectors';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';
export const JiraProjectSelect = () => {
    const { customerId } = useCurrentUser();
    const jiraSummary = useSonarSelector(jiraSummarySelectors.data);
    const patchJiraIntegration = useAction(integrationsActions.requestPatchJiraIntegration);
    const options = useMemo(() => jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.projects.map((project) => ({
        label: project.projectName,
        value: project.projectKey
    })), [jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.projects]);
    const handleOnSelect = useCallback((projectKey) => {
        patchJiraIntegration({
            customerId,
            projectKey
        });
    }, [customerId, patchJiraIntegration]);
    const handleOnClear = useCallback(() => {
        patchJiraIntegration({
            customerId,
            projectKey: null
        });
    }, [customerId, patchJiraIntegration]);
    return (React.createElement(Select, { allowClear: true, className: 'jira-project-select', defaultValue: jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.selectedProjectKey, getPopupContainer: getDirectParent, onClear: handleOnClear, onSelect: handleOnSelect, options: options, placeholder: PLACEHOLDERS_COPY.SELECT_PROJECT }));
};
